import styled from 'styled-components';

export const StyledUserInfo = styled.div`
  ${({ theme, color }) => `
    display: flex;
    position: relative;
    width: fit-content;
    .user-info_section {
      display: flex;
      color: ${color};
      align-items: center;
      cursor: pointer;
      user-select: none;
      .user-info__avatar {
        .MuiAvatar-root, svg {
          width: 40px;
          height: 40px;
        }
      }
      .user-name {
        margin-left: 8px;
        font-weight: 500;
        font-size: 16px;
      }
    }
    .user-info__overlay {
      background: #fff;
      width: 450px;
      border-radius: 12px;
      box-shadow: 0 0 0 0 #f6f3fc, 0 4px 8px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      flex-direction: column;
      padding: 20px;
      position: absolute;
      left: auto;
      top: 50px;
      right: -32px;
      margin-right: 12px;
      z-index: 1;
      &:before {
        content: "";
        border-right: solid 10px transparent;
        border-left: solid 10px transparent;
        border-bottom: solid 20px #fff;
        transform: translateX(50%);
        position: absolute;
        top: -15px;
        right: 32px;
      }
      &-top {
        .MuiAvatar-root, svg {
          width: 40px;
          height: 40px;
        }
        .user-name {
          font-weight: 500;
          font-size: 20px;
          margin-left: 12px;
          color: ${theme.uptimeColors.textColors.secondary};
        }
      }
      &-left {
        .MuiSvgIcon-root {
          width: 24px;
          height: 24px;
          padding-right: ${theme.uptimeSpace[4]}px;
          path {
            fill: ${theme.uptimeColors.grayScales.darkerGray};
          }
        }
      }
      &-right {
        color: ${theme.uptimeColors.grayScales.darkerGray};
        font-weight: 400;
        line-height: 1.5;
        word-break: break-word;
        -ms-word-break: break-word; /*IE 8*/
        white-space: pre-line;
        overflow-wrap: break-word;
        word-wrap: break-word; /*IE 9*/
        &-roles {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          line-height: 1.5;
        }
      }
      &-loading {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 150px;
      }
    }
  `}
`;